const audio = () => {
	const playIconContainer = document.getElementById('play-icon');
	const playIcon = playIconContainer.querySelector('.play');
	const pauseIcon = playIconContainer.querySelector('.pause');
	const pauseBtn = playIconContainer.querySelector('.pause .audio__control');
	const trackList = document.getElementById('album-tracklist');
	const trackListMobile = document.getElementById('album-tracklist-mobile');

	let state = 'play';

	const volumeButtonContainer = document.querySelector(
		'.audio__volume-control',
	);
	const volumeIcon = volumeButtonContainer.querySelector('.volume');
	const muteIcon = volumeButtonContainer.querySelector('.volume-off');
	let volumeState = 'on';
	const volumeSlider = document.getElementById('volume-slider');

	const audio = document.querySelector('#audio-file');
	const audioPlayerContainer = document.getElementById(
		'audio-player-container',
	);

	const durationContainer = document.getElementById('duration');
	const currentTimeContainer = document.getElementById('current-time');
	const seekSlider = document.getElementById('seek-slider');

	let raf = null;

	const next = document.querySelector('.pause > span:nth-of-type(3)');
	const prev = document.querySelector('.pause > span:nth-of-type(1)');
	const mainPlayerNextButton = document.getElementById('right-btn');
	const mainPlayerPrevButton = document.getElementById('left-btn');

	const mainPlayerPlayButton = document.getElementById('main-player-play-btn');
	const activeSongData = document.getElementById('album-preview-wrapper');

	let swiperWrapper = document.getElementById('swiper');

	swiperWrapper.addEventListener('click', () => {
		state = 'pause';
		setActivePlayerIcon();
	});

	const changeMusic = () => {
		whilePlaying();
	};

	function setActivePlayerIcon() {
		state = 'pause';
		playIcon.classList.remove('active');
		pauseIcon.classList.add('active');
		mainPlayerPlayButton.classList.add('active');
	}

	function nextSong() {
		activeSongData.dataset.activeSong =
			Number(activeSongData.dataset.activeSong) + 1;
	}

	function prevSong() {
		activeSongData.dataset.activeSong =
			Number(activeSongData.dataset.activeSong) - 1;
	}

	const handleClickNextButton = () => {
		nextSong();
		changeMusic();
		setActivePlayerIcon();
	};

	const handleClickPrevButton = () => {
		prevSong();
		changeMusic();
		setActivePlayerIcon();
	};

	next.addEventListener('click', handleClickNextButton);
	prev.addEventListener('click', handleClickPrevButton);

	mainPlayerNextButton.addEventListener('click', handleClickNextButton);
	mainPlayerPrevButton.addEventListener('click', handleClickPrevButton);

	function changePlayStatus() {
		if (state === 'play') {
			state = 'pause';
			playIcon.classList.remove('active');
			pauseIcon.classList.add('active');

			mainPlayerPlayButton.classList.add('active');

			audio.play();
			requestAnimationFrame(whilePlaying);
		} else {
			state = 'play';
			playIcon.classList.add('active');
			pauseIcon.classList.remove('active');
			mainPlayerPlayButton.classList.remove('active');
			audio.pause();
			cancelAnimationFrame(raf);
		}
	}
	playIcon.addEventListener('click', () => {
		changePlayStatus();
	});

	pauseBtn.addEventListener('click', () => {
		changePlayStatus();
	});

	mainPlayerPlayButton.addEventListener('click', () => {
		changePlayStatus();
	});

	function changeVolumeIcon() {
		if (volumeState === 'on') {
			volumeState = 'off';
			volumeIcon.classList.remove('active');
			muteIcon.classList.add('active');
			audio.muted = true;
		} else {
			volumeState = 'on';
			volumeIcon.classList.add('active');
			muteIcon.classList.remove('active');
			audio.muted = false;
		}
	}

	volumeButtonContainer.addEventListener('click', changeVolumeIcon);

	function calculateTime(secs) {
		const minutes = Math.floor(secs / 60);
		const seconds = Math.floor(secs % 60);
		const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
		return `${minutes}:${returnedSeconds}`;
	}
	function displayDuration() {
		durationContainer.textContent = calculateTime(audio.duration);
	}

	function setSliderMax() {
		seekSlider.max = Math.floor(audio.duration);
	}

	if (audio.readyState > 0) {
		displayDuration();
		setSliderMax();
	} else {
		audio.addEventListener('loadedmetadata', () => {
			displayDuration();
			setSliderMax();
		});
	}

	function showRangeProgress(rangeInput) {
		if (rangeInput === seekSlider)
			audioPlayerContainer.style.setProperty(
				'--seek-before-width',
				(rangeInput.value / rangeInput.max) * 100 + '%',
			);
		else
			audioPlayerContainer.style.setProperty(
				'--volume-before-width',
				(rangeInput.value / rangeInput.max) * 100 + '%',
			);
	}

	seekSlider.addEventListener('input', (e) => {
		showRangeProgress(e.target);
	});
	volumeSlider.addEventListener('input', (e) => {
		showRangeProgress(e.target);
	});

	function displayBufferedAmount() {
		if (typeof this.buffered !== 'undefined' && this.buffered.length > 0) {
			const bufferedAmount = Math.floor(
				audio.buffered.end(audio.buffered?.length - 1),
			);
			audioPlayerContainer.style.setProperty(
				'--buffered-width',
				`${(bufferedAmount / seekSlider.max) * 100}%`,
			);
		}
	}

	function whilePlaying() {
		seekSlider.value = Math.floor(audio.currentTime);
		currentTimeContainer.textContent = calculateTime(seekSlider.value);
		audioPlayerContainer.style.setProperty(
			'--seek-before-width',
			`${(seekSlider.value / seekSlider.max) * 100}%`,
		);
		raf = requestAnimationFrame(whilePlaying);
	}

	if (audio.readyState > 0) {
		displayDuration();
		setSliderMax();
		displayBufferedAmount();
	} else {
		audio.addEventListener('loadedmetadata', () => {
			displayDuration();
			setSliderMax();
			displayBufferedAmount();
		});
	}

	if (audio.readyState > 0) {
		displayDuration();
		setSliderMax();
		displayBufferedAmount();
	} else {
		audio.addEventListener('loadedmetadata', () => {
			displayDuration();
			setSliderMax();
			displayBufferedAmount();
		});
	}

	audio.addEventListener('progress', displayBufferedAmount);
	seekSlider.addEventListener('input', () => {
		currentTimeContainer.textContent = calculateTime(seekSlider.value);
	});

	seekSlider.addEventListener('input', () => {
		audio.currentTime = seekSlider.value;
		if (!audio.paused) {
			requestAnimationFrame(whilePlaying);
		}
	});
	audio.volume = 0.5;

	volumeSlider.addEventListener('input', (e) => {
		let value = e.target.value;
		audio.volume = value / 100;
		if (value == 0) {
			volumeState = 'on';
			changeVolumeIcon();
		} else {
			volumeState = 'off';
			changeVolumeIcon();
		}
	});
	audio.addEventListener('ended', () => {
		nextSong();
	});

	function handleClickSong(event) {
		activeSongData.dataset.activeSong =
			Array.from(event.currentTarget.children).indexOf(event.target) + 1;
		setActivePlayerIcon();
		changeMusic();
	}

	trackList.addEventListener('click', handleClickSong);
	trackListMobile.addEventListener('click', handleClickSong);
};

module.exports = audio;
